import { useTranslation } from 'react-i18next';

const DEFAULT_LANGUAGE = 'en';

const useLocale = () => {
  const { i18n } = useTranslation();
  const locale = i18n?.resolvedLanguage || i18n?.language || DEFAULT_LANGUAGE;
  const normalized = locale?.toLowerCase();
  const isEn = normalized === 'en' || normalized?.startsWith('en-');
  const isFr = normalized === 'fr' || normalized?.startsWith('fr-');

  return { locale, isEn, isFr };
};

export default useLocale;
